const getters = {
    getStatusList(state) {
        return state.statusList;
    },
    getStatus(state) {
        return state.status;
    }
}

export default getters;